<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  titulo="Grupos de Empresas",
  :max-width="maxWidth",
  :min-width="minWidth",
  :mostrar-confirmar="false",
  texto-cancelar="Fechar"
)
  v-card.pa-2(outlined, elevation="0")
    .d-flex.align-center.justify-space-between.gap-2
      v-spacer
      v-text-field.preview-field.grupos-search(
        v-model="busca",
        placeholder="Buscar por código ou nome",
        prepend-inner-icon="mdi-magnify",
        clearable,
        dense,
        filled,
        rounded,
        hide-details,
        single-line
      )
      v-btn.btn-primario.text-none.ml-1(
        v-if="podeEditar",
        color="primary",
        small,
        :disabled="carregando",
        @click="novoGrupo"
      )
        v-icon(small, left) mdi-plus
        | Adicionar

    .grupos-loader.mt-2
      v-progress-linear(
        :active="carregando",
        indeterminate,
        color="blue",
        height="2"
      )

    .grupos-conteudo.mt-2
      .grupos-empty.text-center(v-if="!grupos.length")
        v-icon.empty-state-icon(size="64", color="blue lighten-3") mdi-sitemap
        .empty-state-title.mt-3 Nenhum grupo encontrado
        .empty-state-subtitle.mt-1 Este cliente ainda não possui grupos de empresas cadastrados.

      v-data-table.grupos-tabela(
        v-else,
        dense,
        :headers="headers",
        :items="grupos",
        :search="busca",
        :footer-props="footerPropsPara(grupos.length)",
        item-key="codigogrupo",
        width="100%",
        elevation="0"
      )
        template(v-slot:item.codigogrupo="{ item: linha }")
          span.grupo-item-codigo {{ linha.codigogrupo }}

        template(v-slot:item.descricao="{ item: linha }")
          span.grupo-item-nome {{ linha.descricao }}

        template(v-slot:item.acoes="{ item: linha }")
          .d-flex.align-center.justify-center(v-if="podeEditar")
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs",
                  v-on="on",
                  icon,
                  x-small,
                  :disabled="carregando || Number(linha.codigogrupo) === 1",
                  @click="editarGrupo(linha)"
                )
                  v-icon(small) mdi-pencil
              span Editar nome

  //- Dialog menor de adicionar/editar. O código é gerado pelo back-end e não é editável.
  base-dialog(
    v-model="dialogForm",
    :titulo="form.codigogrupo ? 'Editar grupo' : 'Novo grupo'",
    :max-width="440",
    persistent,
    texto-confirmar="Salvar",
    :confirmar-desabilitado="!nomeValido",
    :carregando="carregando",
    @confirmar="salvar"
  )
    v-text-field.preview-field.mb-4(
      v-if="form.codigogrupo",
      :value="form.codigogrupo",
      label="Código",
      outlined,
      dense,
      readonly,
      disabled,
      hide-details
    )
    v-text-field.preview-field(
      v-model="form.descricao",
      label="Nome do grupo",
      outlined,
      dense,
      hide-details,
      autofocus,
      :disabled="carregando",
      @keyup.enter="salvar"
    )
</template>

<script>
import BaseDialog from "./BaseDialog";

// Campos esperados em cada grupo: codigogrupo (gerado pelo back-end, não editável),
// e descricao (nome, editável).
export default {
  name: "GruposEmpresaDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    grupos: {
      type: Array,
      default: () => []
    },
    // Só quem pode editar vê Adicionar e Editar. Os demais apenas consultam.
    podeEditar: {
      type: Boolean,
      default: false
    },
    carregando: {
      type: Boolean,
      default: false
    },
    // Mesmas dimensões do LogsDialog.
    maxWidth: {
      type: [String, Number],
      default: 1600
    },
    minWidth: {
      type: [String, Number],
      default: 1200
    }
  },

  data: () => ({
    busca: "",
    dialogForm: false,
    form: { codigogrupo: null, descricao: "" },
    headers: [
      { text: "Código", value: "codigogrupo", align: "start", sortable: true, width: "10%" },
      { text: "Nome", value: "descricao", align: "start", sortable: true, width: "80%" },
      { text: "Ações", value: "acoes", align: "center", sortable: false, width: "10%" }
    ],
    footerProps: {
      itemsPerPageOptions: [50, 100, 300, 500, -1],
      showCurrentPage: true,
      showFirstLastPage: true,
      itemsPerPageText: "Itens por página",
      pageText: "{0}-{1} de {2}"
    }
  }),

  computed: {
    nomeValido() {
      return !!(this.form.descricao && this.form.descricao.trim());
    }
  },

  watch: {
    // Ao abrir, volta ao estado inicial (sem busca e sem formulário).
    value(aberto) {
      if (aberto) {
        this.busca = "";
        this.fecharFormulario();
      }
    }
  },

  methods: {
    novoGrupo() {
      this.form = { codigogrupo: null, descricao: "" };
      this.dialogForm = true;
    },

    editarGrupo(grupo) {
      this.form = { codigogrupo: grupo.codigogrupo, descricao: grupo.descricao || "" };
      this.dialogForm = true;
    },

    // Mesmo comportamento do LogsDialog.
    footerPropsPara(qtd) {
      return qtd > 50 ? this.footerProps : { showCurrentPage: false };
    },

    // Também chamado pela tela depois que o grupo é gravado com sucesso.
    fecharFormulario() {
      this.dialogForm = false;
      this.form = { codigogrupo: null, descricao: "" };
    },

    salvar() {
      if (!this.nomeValido || this.carregando) return;
      this.$emit("salvar", {
        codigogrupo: this.form.codigogrupo,
        descricao: this.form.descricao.trim()
      });
    }
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.grupos-search {
  max-width: 320px;
}

.grupos-loader {
  position: relative;
  height: 2px;
}

/* Mesma altura do conteúdo do LogsDialog. */
.grupos-conteudo {
  height: calc(100vh - 320px);
  overflow-y: scroll;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
}

.grupos-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
}

/* A tabela ocupa a altura do container: o rodapé de paginação fica no fundo. */
.grupos-tabela {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.grupos-tabela ::v-deep .v-data-table__wrapper {
  flex: 1 1 auto;
}

.grupo-item-codigo {
  font-size: 12px;
  color: #424242;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.grupo-item-nome {
  font-size: 12px;
  color: #2c3e50;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.btn-primario {
  height: 30px !important;
  min-width: 96px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}
</style>
